export const IconGrayEmailClosed: {
  name: 'icon_gray_email_closed-0359fb0f7b02'
} = {
  name: 'icon_gray_email_closed-0359fb0f7b02'
}
